import { mergeAll } from 'ramda';
import { log } from '~common/service/logger';
import * as config from '~admin/config.json';

enum BuildType {
  DEBUG = 'debug',
  RELEASE = 'release',
}

enum BuildEnvironment {
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  PRODUCTION = 'production',
  DEMO = 'demo',
}

type FrontendConfig = Readonly<{
  isDebugBuild: boolean;
  isReleaseBuild: boolean;
  enableTestPaths: boolean;
  api: string;
  appUrl: string;
  eventType: string;
  liveConferenceGreeterMediaId: number;
  majorCategoryIds: number[];
  minorCategoryIds: number[];
  numInTour: number;
  paymentVerificationThreshold: number;
  scheduleMediaId: number;
  taxRate: number;
  dateTimeFormats: {
    dateTimeField: string;
  };
}>;

/**
 * The `process.env.NODE_ENV` variable is a special variable "injected" by Webpack
 * at runtime. The word "injected" is in double quotes for a good reason. Indeed,
 * the variable is not really injected, it's really a search & replace at build time
 * that is performed by Webpack. Meaning on the final bundle, this code will look
 * like `return "production"` (assuming `process.env.NODE_ENV` equals `production`).
 */
const getBuildEnvironment = (): string | undefined => process.env.NODE_ENV;

/**
 * The `process.env.DEPLOYMENT_ENVIRONMENT` variable is a special variable "injected" by Webpack
 * at runtime. The word "injected" is in double quotes for a good reason. Indeed,
 * the variable is not really injected, it's really a search & replace at build time
 * that is performed by Webpack. Meaning on the final bundle, this code will look
 * like `return "production"` (assuming `process.env.DEPLOYMENT_ENVIRONMENT` equals
 * `production`).
 */
const getDeploymentEnvironment = (): BuildEnvironment | undefined =>
  process.env.DEPLOYMENT_ENVIRONMENT as BuildEnvironment;

const getBuildType = (): BuildType => {
  const buildEnvironment = getBuildEnvironment();

  if (buildEnvironment === undefined || buildEnvironment === 'development') {
    return BuildType.DEBUG;
  }

  return BuildType.RELEASE;
};

const computeConfig = (environment: BuildEnvironment): FrontendConfig => {
  const buildType = getBuildType();
  log.info('Build type [%s].', buildType);
  log.info('Deployment environment [%s].', environment);

  const commonConfig: Partial<FrontendConfig> = {
    isDebugBuild: buildType === BuildType.DEBUG,
    isReleaseBuild: buildType === BuildType.RELEASE,
  };
  const baseConfig: Partial<FrontendConfig> = config.base;
  const environmentConfig: Partial<FrontendConfig> = config[environment] || {};
  return mergeAll([commonConfig, baseConfig, environmentConfig]) as FrontendConfig;
};

export const Config = computeConfig(getDeploymentEnvironment());



// WEBPACK FOOTER //
// ./config.ts